









import {Vue, Watch} from "vue-property-decorator";
import Component from "vue-class-component";
import {Action, Getter} from "vuex-class";
import Dashboard from "@/components/dashboard/Dashboard.vue";
import {GridProfile} from "@/modules/GridProfile";
import {ptfFeatures} from "@/Constants";
import _ from "lodash";
import Owner from "@/model/cospirit-api/Owner";

const components = {
    Dashboard,
};

@Component({components})
export default class Home extends Vue {
    protected loading: boolean = false;
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;
    @Getter("getGridProfile") public profile!: GridProfile;
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;
    @Getter("getCurrentUser") public currentUser!: any;
    @Action("loadGridProfile") public loadGridProfile!: () => Promise<void>;

    @Watch("currentOwnerUuid") protected currentOwnerUuidChanged(): void {
        this.checkAccess();
        this.reloadProfile();
    }

    protected created() {
        this.checkAccess();

    }

    protected mounted() {
        this.reloadProfile();
    }

    protected checkAccess() {
        if (!this.hasFeature(ptfFeatures.homepage) || _.some(this.currentUser.userHideFeatures, (line) => {
            return line.code === "HIDE_HOMEPAGE";
        })) {
            this.$router.push({name: "redirect"});
        }
    }

    protected reloadProfile() {
        this.loading = true;
        if (this.currentOwnerUuid) {
            this.loadGridProfile().finally(() => {
                this.loading = false;
            });
        }
    }
}
